<template>
  <div>
    <h1>{{ $route.meta.title }}</h1>
    <div class="trello-container">
      <div class="demande-container">
        <div class="heading">
          <h3>Nouvelle demande</h3>
        </div>
          <div class="demande-body">
            <div class="demande-form row">
              <!-- Première ligne -->
              <div class="row">
                <div class="form-group col">
                  <label>Type de demande :</label>
                  <select class="form-control" v-model="demandeType">
                    <option :value="_td.color" v-for="_td in typeDemande" :key="_td.color">{{ _td.name }}</option>
                  </select>
                </div>
                <div class="form-group col">
                  <label>Date souhaitée :</label>
                  <input type="date" class="form-control" v-model="demandeObject.dateSouhaitee" />
                </div>
              </div>
              <!-- Deuxième ligne -->
              <div class="row">
                <div class="form-group col">
                  <label>Projet concerné :</label>
                  <select class="form-control" v-model="demandeObject.projet">
                    <option :value="_p.name" v-for="_p in projets" :key="_p.id">{{ _p.name }}</option>
                  </select>
                </div>
                <div class="form-group col">
                  <label>Priorité :</label>
                  <select class="form-control" v-model="demandeObject.priorite">
                    <option :value="_p.priorite" v-for="_p in priorites" :key="_p.priorite" :class="_p.color">{{ _p.label }}</option>
                  </select>
                </div>
              </div>
              <!-- Description -->
              <div class="row">
                <div class="form-group col">
                  <label>Titre de la demande :</label>
                  <input type="text" class="form-control" v-model="demandeName" />
                </div>
              </div>
              <!-- Description -->
              <div class="row">
                <div class="form-group col">
                  <label>Description :</label>
                  <textarea class="form-control" v-model="demandeObject.description"></textarea>
                </div>
              </div>
              <!-- Screenshot -->
              <div class="row">
                <div class="form-group col">
                  <label>Pages écran :</label>
                  <div>
                    <input type="file" @change="loadFile"/>
                  </div>
                  <ul class="attachments-preview">
                    <li v-for="(attach, i) of attachments" :key="i" class="d-flex justify-content-between">
                      <div class="preview">
                        {{attach.file.name}}
                        <img v-if="attach.file.type.split('/')[0] == 'image'" :src="attach.url" />
                        <iframe v-else-if="attach.file.type == 'application/pdf'" :src="attach.url" />
                      </div>
                      <button @click="attachments = [...attachments.slice(0, i), ...attachments.slice(i + 1)]">X</button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <hr />
                <div class="form-group col">
                  <button class="button-primary" v-on:click="sendDemande()">Envoyer</button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    createCard,
    getLabels,
    addAttachment
  } from "@/utils/trello";
import { getUserInitials } from "@/utils/user";
 

  export default {
    name: "TicketDemande",
    data() {
      return {
        typeDemande: [],
        projets: [],
        priorites: [],
        attachments: [],
        // Objet utilisé pour la demande
        demandeObject: {
          type: "demandeCustom",
          demandeur: {
            sdcGuid: "",
            fullName: "",
            initiales: "",
          },
          projet: "",
          priorite: 0,
          dateSouhaitee: "",
          description: ""
        },
        // Elements du ticket Trello
        demandeName: "",
        demandeType: "",
        // Labels
        labels: [],
      }
    },
    mounted() {
      this.initDatas();
    },
    watch: {

    },
    methods: {
      initDatas() {
        this.typeDemande = this.$store.state.trelloConfig.typeDemandeConfig;
        this.projets = this.$store.state.trelloConfig.projetsConfig;
        this.priorites = this.$store.state.trelloConfig.prioriteConfig;

        getLabels(this.$store.state.trelloConfig.internalBoard.idBoard).then(r => {
          this.labels = r;
        })
      },
      loadFile(e) {
        // On ajoute un aperçu
        const file = e.target.files.length ? e.target.files[0] : null
        if (file) {
          const url = URL.createObjectURL(file);
          this.attachments.push({ file, url });
          //addAttachment("62026f4e4e9212410876dd07", file, file.type);
          e.target.value = "";
        }
      },

      // Requête de création de la demande
      sendDemande() {
        var demandeFull = this.typeDemande.find(d => d.color == this.demandeType);
        if (demandeFull == undefined || demandeFull == null || demandeFull == "") {
          alert('Merci de vérifier que tous les champs sont bien renseignés');
          return;
        }
        var label = this.labels.find(l => l.name == demandeFull.name && l.color == demandeFull.color);


        // On met à jour les informations de l'utilisateur
        let fullName = this.$store.state.self.firstname + " " + this.$store.state.self.name;

        //if (this.$store.state.self.IsAdmin)
        this.demandeObject.demandeur.sdcGuid = this.$store.state.self.userSdcGuid;
        //else this.demandeObject.demandeur.sdcGuid = "";

        this.demandeObject.demandeur.fullName = fullName;
        this.demandeObject.demandeur.initiales = getUserInitials(fullName);

        // Appel de l'api
        createCard(
          this.demandeName,
          JSON.stringify(this.demandeObject),
          "",
          this.$store.state.trelloConfig.internalBoard.idList,
          JSON.stringify([label.id]),
          JSON.stringify([]),
        ).then(c => {
          var _promises = [];

          this.attachments.forEach(a => {
            _promises.push(addAttachment(c.id, a.file, a.file.type));
          })

          // Une fois toutes les pièces jointes ajoutées
          Promise.all(_promises).then(res => {
            if (this.$store.state.self.IsAdmin)
              this.$router.push({ name: 'TicketDetail', query: { id: c.id } })
            else this.$router.back();
          });
        })
      }
    },
  }
</script>

<style scoped>
  .trello-container {
    width: 50%;
    min-width: 600px;
    margin: auto;
  }

  .demande-container {
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    overflow-x: hidden;
  }

    .demande-container .heading {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #BEBEBE;
    }

      .demande-container .heading > h3 {
          font-size: 1.50rem;
      }

  .demande-body {
    
  }

    .demande-body > h4 {
      font-size: 1.2rem;
    }


      .priorityBadge {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: black;
        margin: auto;
      }

    .priorityBadge.priority-0 {
      background-color: transparent;
      border: 1px solid #CCC;
    }

    .priorityBadge.priority-1 {
      background-color: rgb(237, 215, 71);
    }

    .priorityBadge.priority-2 {
      background-color: rgb(242, 162, 64);
    }

    .priorityBadge.priority-3 {
      background-color: rgb(218, 100, 79);
    }

  .badges .priority-badge {
    width: 100%;
    padding: 0.5rem 0.7rem;
    color: white;
    font-size: 0.8rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

    .badges .priority-badge:nth-child(1) {
      background-color: rgb(237, 215, 71);
    }

    .badges .priority-badge:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }

    .badges .priority-badge:nth-child(3) {
      background-color: rgb(218, 100, 79);
    }

  .board-box .progress-bar {
    display: grid;
    justify-content: start;
    width: 100%;
    height: 16px;
    overflow: hidden;
    background-color: white;
    border: 1px solid #A7C13C;
    border-radius: 12px;
    margin-bottom: 15px;
    margin-top: 8px;
  }

    .board-box .progress-bar div:nth-child(1) {
      background-color: #A7C13C;
    }

    .board-box .progress-bar div:nth-child(2) {
      background-color: rgb(242, 162, 64);
    }


    .form-group label {
        border-left: solid 3px #A7C13C;
        width: 100%;
        margin-bottom: 8px;
        margin-top: 12px;
        padding-left: 3px;
    }

  .attachments-preview li {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
  }

    .attachments-preview li .preview {
        flex-grow: 1;
    }

      .attachments-preview li .preview img {
        display: block;
        width: 64px;
        height: auto;
      }

      .attachments-preview li .preview iframe {
        display: block;
        height: 164px;
        max-width: 50%;
      }

</style>



// WEBPACK FOOTER //
// src/pages/GestionProjet/TicketDemande.vue